/* REVIVAL FESTIVAL: 今売れているランキング（sections/rf-bestsellers.liquid）
 * 公開集計 API の snapshot.bestsellers（集計値のみ）を読み、期間 × カテゴリの TOP5 を表示する。
 * 他の rf-* の JS とは独立。ページ上のどの要素も書き換えず、このセクションの中だけを描画する。 */
(function () {
  'use strict';
  if (window.__rfBestsellers) return; window.__rfBestsellers = true;
  var GROUPS = ['eco', 'cooler', 'furoshiki'], PERIODS = ['realtime', 'daily', 'all'];
  var CROWN = '<svg class="rf-bs__crown" viewBox="0 0 60 34" aria-hidden="true" focusable="false"><path d="M6 30 L3 9 L17 19 L30 4 L43 19 L57 9 L54 30 Z"/><circle cx="3" cy="8" r="3"/><circle cx="30" cy="4" r="3.4"/><circle cx="57" cy="8" r="3"/><rect x="6" y="28" width="48" height="5" rx="1.5"/></svg>';
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function readJson(root, sel) { try { var el = root.querySelector(sel); return el ? JSON.parse(el.textContent) : {}; } catch (e) { return {}; } }
  function fmtTime(iso) {
    var d = new Date(iso); if (isNaN(d)) return '';
    var j = new Date(d.getTime() + 9 * 3600000); // 日本時間で表示
    var p = function (n) { return (n < 10 ? '0' : '') + n; };
    return (j.getUTCMonth() + 1) + '/' + j.getUTCDate() + ' ' + j.getUTCHours() + ':' + p(j.getUTCMinutes());
  }

  function init(root) {
    var items = readJson(root, '[data-rf-bs-items]'), text = readJson(root, '[data-rf-bs-text]');
    var list = root.querySelector('[data-rf-bs-list]'), state = root.querySelector('[data-rf-bs-state]');
    var caption = root.querySelector('[data-rf-bs-caption]'), updated = root.querySelector('[data-rf-bs-updated]');
    var unit = root.getAttribute('data-unit') || '', upd = root.getAttribute('data-updated') || '';
    var cur = { period: 'all', group: 'cooler' }, data = null, failed = false;

    function render() {
      caption.textContent = ((text.captions || {})[cur.period] || '') + ' ／ ' + ((text.groups || {})[cur.group] || '');
      if (!data) { list.innerHTML = ''; state.hidden = false; state.textContent = root.getAttribute(failed ? 'data-text-error' : 'data-text-loading') || ''; updated.textContent = ''; return; }
      updated.textContent = data.updated_at ? fmtTime(data.updated_at) + ' ' + upd : '';
      var p = (data.bestsellers || {})[cur.period] || {}, rows = ((p.ranking || {})[cur.group] || []).slice(0, 5);
      if (!rows.length) { list.innerHTML = ''; state.hidden = false; state.textContent = root.getAttribute('data-text-empty') || ''; return; }
      state.hidden = true;
      var max = rows[0].units || 1;
      list.innerHTML = rows.map(function (r, i) {
        var it = items[r.key] || {}, img = ((it.img || {})[cur.group]) || '';
        var rank = i + 1, tier = rank === 1 ? 'gold' : rank === 2 ? 'silver' : rank === 3 ? 'bronze' : 'plain';
        var pct = Math.max(4, Math.round((r.units / max) * 100));
        var name = it.name || r.key;
        return '<li class="rf-bs__item rf-bs__item--' + tier + '">' +
          '<div class="rf-bs__rank">' + (rank <= 3 ? CROWN : '') + '<span class="rf-bs__num">' + rank + '</span><span class="rf-bs__sr">位</span></div>' +
          '<div class="rf-bs__thumb">' + (img ? '<img src="' + esc(img) + '" alt="' + esc(name + (it.note || '')) + '" width="240" height="240" loading="lazy" decoding="async">' : '') + '</div>' +
          '<div class="rf-bs__body"><p class="rf-bs__name">' + esc(name).split('×').join('×<br>') + (it.note ? '<span class="rf-bs__name-note">' + esc(it.note) + '</span>' : '') + '</p>' +
          '<div class="rf-bs__meter"><span class="rf-bs__bar" style="width:' + pct + '%"></span></div></div>' +
          '<p class="rf-bs__units"><b>' + Number(r.units).toLocaleString('ja-JP') + '</b>' + esc(unit) + '</p></li>';
      }).join('');
    }

    function tabs(sel, key) {
      var btns = Array.prototype.slice.call(root.querySelectorAll(sel));
      btns.forEach(function (b, i) {
        b.addEventListener('click', function () { select(i); });
        b.addEventListener('keydown', function (e) {
          var k = e.key, n = k === 'ArrowRight' ? i + 1 : k === 'ArrowLeft' ? i - 1 : k === 'Home' ? 0 : k === 'End' ? btns.length - 1 : null;
          if (n === null) return; e.preventDefault(); select((n + btns.length) % btns.length); btns[(n + btns.length) % btns.length].focus();
        });
      });
      function select(i) {
        btns.forEach(function (b, j) { b.setAttribute('aria-selected', j === i ? 'true' : 'false'); b.tabIndex = j === i ? 0 : -1; });
        cur[key] = btns[i].getAttribute(key === 'period' ? 'data-period' : 'data-group'); render();
      }
    }
    tabs('.rf-bs__period', 'period'); tabs('.rf-bs__group', 'group');

    var url = root.getAttribute('data-url'), every = Math.max(30, Number(root.getAttribute('data-refresh')) || 60) * 1000, timer = null;
    function load() {
      if (!url) { failed = true; render(); return; }
      fetch(url, { credentials: 'omit', cache: 'no-cache' }).then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
        .then(function (j) { if (!j || !j.bestsellers) throw new Error('no data'); data = j; failed = false; render(); })
        .catch(function () { failed = !data; render(); });
    }
    function schedule() { clearTimeout(timer); timer = setTimeout(function () { if (!document.hidden) load(); schedule(); }, every); }
    document.addEventListener('visibilitychange', function () { if (!document.hidden) load(); });
    render(); load(); schedule();
  }

  function start() { Array.prototype.forEach.call(document.querySelectorAll('[data-rf-bs]'), function (r) { if (!r.__rfBs) { r.__rfBs = true; init(r); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', start); // テーマエディタ
})();
